



































import Vehicle from "@/data/models/Vehicle";
import { observeVehicles } from "@/data/repository/VehicleRepository";
import { COLOR_TABLE_HEADER, COLOR_TABLE_HEADER_DARK } from "@/utils/colors";
import { themed } from "@/utils/Theme";
import { Component, Vue } from "vue-property-decorator";
import VehicleDevicesItemComponent from "./VehicleDevicesItemComponent.vue";
import { calculateBackgroundStyle, setLastVisitedItem, StorageKeyLastVisitedItemLevel } from "@/utils/Utils";
import router from "@/router/router";

const LAST_VEHICLE_TOUCHED_PREFIX = "VEHICLE_DEVICES";

@Component({
  name: "VehiclesComponent",
  components: {
    "vehicle-devices-item": VehicleDevicesItemComponent,
  },
})

export default class VehiclesComponent extends Vue {
  vehicles: Vehicle[] = [];
  subscriptions: Array<() => void> = [];
  /**
   * Keeps track of the last‑visited vehicle so that Vue re‑renders
   * when the selection changes.
   */
  lastVisitedKey = "";

  get tableHeaderColor() {
    return themed(COLOR_TABLE_HEADER, COLOR_TABLE_HEADER_DARK);
  }
  
  async created() {
    this.subscriptions.push(
      observeVehicles((vehicles) => {
        this.vehicles = vehicles;
      })
    );
  }

  beforeDestroy() {
    this.subscriptions.forEach(unsub => unsub());
    this.subscriptions = [];
  }

  calculateBackgroundStyle(itemId: string) {
    // Touch the reactive flag so Vue knows to re‑evaluate when it changes
    this.lastVisitedKey;
    return calculateBackgroundStyle(`${LAST_VEHICLE_TOUCHED_PREFIX}/${itemId}`);
  }

  async openVehicleDetails(vehicle: Vehicle) {
    // Persist selection in local storage
    this.lastVisitedKey = `${LAST_VEHICLE_TOUCHED_PREFIX}/${vehicle.id}`;
    setLastVisitedItem(
      this.lastVisitedKey,
      StorageKeyLastVisitedItemLevel.LEVEL_1
    );

    router.push({
      path: "vehicleDevices",
      query: {
        vehicleId: vehicle.id,
      },
    });
  }
}
